import { useSelector } from 'react-redux';
import { cn } from '../../../../utils';
import MovingCircle from './MovingCircle';

export default function SwitchProfileLoader({className}) {
  const lang = useSelector(({ common }) => common?.language);
  
  return (
    <div
      className={cn(
        'flex h-[418px] flex-col items-center justify-center gap-[12px]',
        className
      )}
    >
      <MovingCircle className='h-16 w-16' variant='black' />
      <div>
        <p>{lang?.common?.switching_profile}</p>
        <p>{lang?.common?.please_wait_a_bit}</p>
      </div>
    </div>
  );
}
